module.exports = __webpack_public_path__ + "static/media/5.940bfe87.png";